import type { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import classNames from 'classnames';
import svgStyles from './SVGStyles.module.css';

export default function PlaySvg({ className }: StandardSvgProps) {
    const playPath =
        "M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20S31,0,20,0z" +
        "M26.9,21.1l-10,6.2c-0.6,0.4-1.4,0.2-1.7-0.4c-0.1-0.2-0.2-0.4-0.2-0.7V13.8c0-0.7,0.6-1.2,1.3-1.2c0.2,0,0.5,0.1,0.7,0.2l10,6.2c0.6,0.4,0.8,1.1,0.4,1.7C27.2,20.8,27.1,21,26.9,21.1z";

    return (
        <svg className={classNames(svgStyles.SDefaultSvg, className)} viewBox="0 0 40 40">
            <defs>
                <linearGradient id="linear-playGradient" gradientTransform="rotate(-20)">
                    <stop offset="0" stopColor="var(--custom-gradient-stop0, var(--palette-melrose2))" />
                    <stop offset="0.241" stopColor="var(--custom-gradient-stop1, var(--palette-french-pass))" />
                    <stop offset="0.488" stopColor="var(--custom-gradient-stop2, var(--palette-your-pink))" />
                    <stop offset="0.764" stopColor="var(--custom-gradient-stop3,var(--palette-illusion))" />
                    <stop offset="1" stopColor="var(--custom-gradient-stop4,var(--palette-melrose2))" />
                </linearGradient>
            </defs>
            <path d={playPath} />
        </svg>
    );
}
